import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
  title = 'Rooftop Solar Systems & Installation | Price, Subsidy | VaySolar India',
  description = 'Get a rooftop solar system at the right price, claim 2026 subsidy and book installation in 3 clicks. VaySolar handles survey, finance and 100 % generation guarantee.',
  name = 'VaySolar',
  type,
  image,
}) {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name='description' content={description} />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property='og:type' content={type} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={image} />
      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name='twitter:creator' content={name} />
      <meta name='twitter:card' content={type} />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={image} />
      {/* End Twitter tags */}
      {/* Favicon */}
      <link rel='icon' href={image} />
      {/* End Favicon */}
    </Helmet>
  );
}
